import axios from 'axios'
// import { cacheAdapterEnhancer } from 'axios-extensions';


// const http = axios.create({
// 	baseURL: '/',
// 	// headers: { 'Cache-Control': 'no-cache' },
// 	// disable the default cache and set the cache flag
// 	adapter: cacheAdapterEnhancer(axios.defaults.adapter, { 
// 		enabledByDefault: true,
// 		// cacheFlag: 'fromCache'
// 	})
// });

export default axios;